import { defineMessage, defineMessages, MessageDescriptor } from 'react-intl';

/**
 * Form label for the date range field.
 */
export const dateRangeLabel = defineMessage({
  id: 'common.datetimeRange',
  defaultMessage: 'Rango de fecha y hora',
});

/**
 * Help label.
 */
export const helpLabel = defineMessage({
  id: 'common.help',
  defaultMessage: 'Ayuda',
});

/**
 * Centralized group-by option label messages.
 * Use with formatMessage so the extractor picks up the ids and defaultMessages.
 *
 * @example
 * <FormattedMessage {...groupByLabelMessages.NONE} />
 */
export const groupByLabelMessages: Record<string, MessageDescriptor> = defineMessages({
  NONE: {
    id: 'audit.missingAudios.groupBy.none',
    defaultMessage: 'No agrupar',
  },
  CUSTOM_ID: {
    id: 'audit.missingAudios.groupBy.custom_id',
    defaultMessage: 'Custom ID',
  },
  CUSTOM_ID_STATION_ID: {
    id: 'audit.missingAudios.groupBy.custom_id_station_id',
    defaultMessage: 'Custom ID y emisora',
  },
});

/**
 * Maps group-by option id (from groupByOptions) to the corresponding message descriptor.
 */
export const groupByOptionToLabelMessage: Record<string, MessageDescriptor> = {
  none: groupByLabelMessages.NONE,
  custom_id: groupByLabelMessages.CUSTOM_ID,
  'custom_id,station_id': groupByLabelMessages.CUSTOM_ID_STATION_ID,
};
